import axios from 'axios'
import linq from 'linq'

export const getItems = async () => {
    const { data } = await axios.get('/api/cart/get')
    linq.from(data).forEach((x) => {
        if (x.image) {
            x.item.product.img_path = x.image
        }
    })

    return data
}

export const addCartItem = async (items) => {
    const cartItem = await getItems()
    const isDuplication = items.some(x => {
        const res = cartItem.find(_item => _item.item.id === x.item_id)
        return !!res
    })
    if(isDuplication) {
        if (!alert('同じ商品がカートに存在します')) {
            return false
        }
    }
    await axios.post('/api/cart/add', items)

    return true
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/CartService.js